import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import type { ApiBOTypesData } from "@src/api/bo/boTypes/types";
import type { ApiDivisionTypeItem } from "@src/api/dictionaries/divisions/types";
import type { ApiSoType } from "@src/api/so/types";
import { isZustandDevtoolsEnabled } from "./zustandDevtoolsEnabled";

/** Ключ persist для reference store. */
export const REFERENCE_STORE_LOCAL_KEY = "reference-storage";

interface ReferenceState {
    /** Типы подразделений, загруженные на bootstrap. */
    divisionTypes: ApiDivisionTypeItem[];
    /** Типы БО, загруженные на bootstrap. */
    boTypes: ApiBOTypesData[];
    /** Типы СО, загруженные на bootstrap. */
    soTypes: ApiSoType[];
}

interface ReferenceStateActions {
    setDivisionTypes: (divisionTypes: ApiDivisionTypeItem[]) => void;
    setBoTypes: (boTypes: ApiBOTypesData[]) => void;
    setSoTypes: (soTypes: ApiSoType[]) => void;
    clearStore: () => void;
}

const initialState: ReferenceState = {
    divisionTypes: [],
    boTypes: [],
    soTypes: [],
};

/**
 * App-level store справочных session-данных (типы подразделений, БО, СО и др.).
 */
export const useReferenceStore = create<ReferenceState & ReferenceStateActions>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,
                setDivisionTypes: (divisionTypes) => {
                    set({ divisionTypes }, false, "setDivisionTypes");
                },
                setBoTypes: (boTypes) => {
                    set({ boTypes }, false, "setBoTypes");
                },
                setSoTypes: (soTypes) => {
                    set({ soTypes }, false, "setSoTypes");
                },
                clearStore: () => {
                    set(initialState, false, "clearStore");
                },
            }),
            {
                name: REFERENCE_STORE_LOCAL_KEY,
                partialize: (state) => ({
                    divisionTypes: state.divisionTypes,
                    boTypes: state.boTypes,
                    soTypes: state.soTypes,
                }),
            },
        ),
        {
            name: REFERENCE_STORE_LOCAL_KEY,
            enabled: isZustandDevtoolsEnabled,
            trace: true,
        },
    ),
);

export default useReferenceStore;
